import React from "react";

import RequestDemo from "./ContactUsForm";

import "./Contact.css";

export default function Contact() {
  return (
    <div>
      <div className="guest-contacts-background2">
        <RequestDemo />
      </div>
    </div>
  );
}
